<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Locations"
                        sub-title="Creating new location data"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button v-if="parent" element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'locations.home' })">
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="opening-hours" :handle-click="toggle" :active="active">Opening hours</app-tabs-trigger>
                    <app-tabs-trigger name="address" :handle-click="toggle" :active="active">Address</app-tabs-trigger>
                    <app-tabs-trigger name="location-details" :handle-click="toggle" :active="active">Location details</app-tabs-trigger>
                    <app-tabs-trigger name="response-tap" :handle-click="toggle" :active="active">ResponseTap</app-tabs-trigger>
                    <app-tabs-trigger name="google" :handle-click="toggle" :active="active">Google</app-tabs-trigger>
                    <app-tabs-trigger name="trustpilot" :handle-click="toggle" :active="active">Trustpilot</app-tabs-trigger>
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">
                        <app-field-select
                            :required="true"
                            label="Location"
                            :items="items.locations"
                            v-model="fields.location_id"
                            :error="errors.location_id"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="opening-hours" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Monday"
                                    v-model="fields.opening_hours.monday"
                                    :error="errors.monday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Tuesday"
                                    v-model="fields.opening_hours.tuesday"
                                    :error="errors.tuesday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Wednesday"
                                    v-model="fields.opening_hours.wednesday"
                                    :error="errors.wednesday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Thursday"
                                    v-model="fields.opening_hours.thursday"
                                    :error="errors.thursday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Friday"
                                    v-model="fields.opening_hours.friday"
                                    :error="errors.friday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Saturday"
                                    v-model="fields.opening_hours.saturday"
                                    :error="errors.saturday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Sunday"
                                    v-model="fields.opening_hours.sunday"
                                    :error="errors.sunday"
                                />
                            </div>
                        </div>
                    </app-tabs-content>

                    <app-tabs-content name="address" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                The address information can only be amended after you've created the location.
                            </div>
                        </div>
                    </app-tabs-content>

                    <app-tabs-content name="location-details" :active="active">
                        <app-field-trix
                            :required="false"
                            label="Location details"
                            v-model="fields.description"
                            :error="errors.description"
                        />

                        <app-field-filea
                            :required="false"
                            label="Image"
                            v-model="fields.image"
                            :error="errors.image"
                            helper="Maximum width: 350px"
                            :types="{images: true, files: false}"
                        />
                    </app-tabs-content>

                    <app-tabs-content name="response-tap" :active="active">
                        <app-field-text
                            :required="true"
                            label="ResponseTap Number"
                            v-model="fields.responsetap_number"
                            :error="errors.responsetap_number"
                        />

                       <app-field-text
                            :required="false"
                            label="Hidden number on site"
                            v-model="fields.rt_hidden_number"
                            :error="errors.rt_hidden_number"
                        />
                    </app-tabs-content>

                    <app-tabs-content name="google" :active="active">
                        <div class="border-b-4 mb-5">
                            Google Reviews (this is NOT implemented yet as we're awaiting approval from Google)<br/><br/>
                            <app-field-text
                                :required="false"
                                label="Location Google Place ID"
                                v-model="fields.google_reviews_data.place_id"
                            />

                            <app-field-toggle
                                :required="false"
                                label="Enabled?" 
                                v-model="fields.google_reviews_data.published"
                            />
                        </div>

                        <div>
                            Google Tour<br/><br/>
                            <app-field-text
                                :required="false"
                                label="Google Tour link"
                                v-model="fields.google_tour"
                            />
                        </div>
                    </app-tabs-content>

                     <app-tabs-content name="trustpilot" :active="active">
                        <app-field-text
                            :required="false"
                            label="Trustpilot location (this needs to be the 'data-location' attribute from Trustpilot)"
                            v-model="fields.trustpilot"
                        />
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CategoryField from '@/components/fields/inputs/Category';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import TrixField from '@/components/fields/inputs/Trix';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import SEO from '@/components/SEO';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'locations.new',

        data: () => ({
            parent: false,
            fields: {
                location_id: '',
                description: '',
                responsetap_number: '',
                rt_hidden_number: '',
                trustpilot: '',
                google_tour: '',
                opening_hours: {
                    monday: '',
                    tuesday: '',
                    wednesday: '',
                    thursday: '',
                    friday: '',
                    saturday: '',
                    sunday: '',
                },
                 address: {
                    line_1: '',
                    line_2: '',
                    city: '',
                    county: '',
                    postcode: '',
                    country: '',
                },
                geo: {
                    lat: '',
                    lng: '',
                },
                google_reviews_data: {
                    place_id: '',
                    published: false
                }
            },
            items: {
                locations: []
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-category': CategoryField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-trix': TrixField,
            'app-field-currency': CurrencyField,
            'app-field-repeatable': RepeatableField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-seo-widget': SEO
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            this.loading = true;

            this.getLocations()
                .then(response => {
                    if (typeof this.$route.params.id != 'undefined') {
                        this.getArticle(this.$route.params.id)
                            .then(response => {
                                this.setLocales();

                                for (let index in this.parent) {
                                    if (typeof this.fields[index] !== 'undefined') {
                                        this.fields[index] = this.parent[index];
                                    }
                                }

                                this.fields.parent_id = this.$route.params.id;
                            });
                    }
                })
                .then(response => {
                    this.loading = false;
                });
        },

        computed: {
            ...mapGetters({

            })
        },

        methods: {
            getLocations() {
                return Api.request('get', `locations/locations`)
                    .then(({ data }) => {
                        this.items.locations = data.locations;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', 'locations/create', this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'locations.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/locations/New.vue